import OnboardCoverageContainer from './components/OnboardCoverageContainer';

export default OnboardCoverageContainer;
